import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DateTimeAdapter } from 'ng-pick-datetime';
import { AuthenticationService } from './services/authentication.service';
import { UserSessionService } from './services/usersession.service';

// @HostListener("window:onbeforeunload", ["$event"])
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  title = 'Promotional Ride';
  returnUrl: any;
 // public validinput = "^(?:[^()]*|[^()]*\([^()]*\)[^()]*)$";
  public validinput:RegExp = /^[^\s]+(\s+[^\s]+)*$/;
  tokenData: any;
  constructor(dateTimeAdapter: DateTimeAdapter<any>,
    private router: Router,
    private route: ActivatedRoute,  private authService: AuthenticationService, private sessionService: UserSessionService) {
    dateTimeAdapter.setLocale('en-in');
  }

  ngOnInit(): void {
    debugger
    // if(data=='true'){
    //   this.router.navigate(['/error']);
      
    // }else{
    //   this.router.navigate(['/error']);

    // }
    // this.router.navigate(['/dashboard']);
    // this.router.events.subscribe((e) => {
    //   if (e instanceof NavigationEnd) {
    //     if (e.url === '/incomereport' || e.url === '/refuelreport'
    //     || e.url === '/distancereport' || e.url === '/tripreport' 
    //     || e.url === '/tripstatusreport' || e.url === '/podturnaround'
    //       || e.url.startsWith('/users/')
    //       || e.url.startsWith('/dashboard')
    //     ) {
    //       document.body.classList.add('removeglobalfilter');
    //     } else {
    //       document.body.classList.remove('removeglobalfilter');
    //     }
    //   }
    // });
  }
  userlogin() {
  
    var url = new URL(window.location.href);
    this.tokenData = decodeURIComponent(url.searchParams.get("token"));
    if(this.tokenData == 'null' || this.tokenData == null || this.tokenData == undefined || this.tokenData == '' ) {
      // No token passed, check in local storage.
      var authTokenFromStorage = this.sessionService.authToken();
      if(authTokenFromStorage == null || authTokenFromStorage == '' || authTokenFromStorage == undefined ) {
        console.log("Appcomponent- error - 1");
        // Fresh login scenario
          this.authService.logOut();
          this.router.navigate(['/error']);
      } else {
        localStorage.setItem('isLoggedin', 'true');
        this.router.navigate(['/dashboard']);
      }
    } else {
     
          let data = {
            "username": "",
            "password": "",
            "ui": "",
            "token": this.tokenData,
          }
          console.log(this.tokenData);
          console.log("2 - User login before token fetch");
            // this.authService.login(data).subscribe(result => {
            //   if(result.access_token!=null){
            //     this.authService.validateLogin(result);
            //     localStorage.setItem('isLoggedin', 'true');
            //     console.log("3 - User login after token auth");

            //     this.router.navigate(['/dashboard']);
        
            //   }else{
            //     console.log("3B Errror - User login after token auth");

            //     this.authService.logOut();
            //     this.router.navigate(['/error']);
            //   }
            //   // console.log(result,"api token");
            //   // console.log("logim");
          
            //   // this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
          
            //   // this.router.navigate([this.returnUrl]);
        
              
            //   // this.userIdle.startWatching();
        
            // });
      }
    }

  clearAllData() {
    // this.authService.logOut();
  }

}
